import { render, staticRenderFns } from "./statisticCategory.vue?vue&type=template&id=435731a4&"
import script from "./statisticCategory.vue?vue&type=script&lang=js&"
export * from "./statisticCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports